import { Box } from '@chakra-ui/react';
import { Alert } from "@/components/ui/alert"

export default function ErrorMessage({ message }) {
  return (
    <Box my={4} zIndex={51}>
      <Alert status="error" borderRadius={4}>
        {message}
      </Alert>
    </Box>
  );
}